import superagent from 'superagent'

export default function hookLogicService(hookLogicUrl) {
  const responseTimeout = window.criteoResponseTimeout !== 'undefined' ? window.criteoResponseTimeout : 1000
  const deadlineTimeout = window.criteoDeadlineTimeout !== 'undefined' ? window.criteoDeadlineTimeout : 2000

  const parseResponseText = text => {
    try {
      return JSON.parse(text)
    } catch (error) {
      return {}
    }
  }

  return new Promise((resolve, reject) => {
    superagent
      .get(hookLogicUrl)
      .set('Accept', `application/json`)
      .timeout({
        response: responseTimeout,
        deadline: deadlineTimeout
      })
      .end((err, response) => {
        if (err) {
          resolve({ timeout: true })
        }
        if (response && response.text) {
          resolve(parseResponseText(response.text))
        }
      })
  })
}
